import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import { storefront } from '../lib/supabase';
import { formatVND, pickLang } from '../lib/format';

export default function SaleOffers() {
  const { lang, t } = useLang();
  const [promos, setPromos] = useState([]);
  const [tiers, setTiers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([storefront.promotions(), storefront.offerTiers()])
      .then(([p, o]) => {
        const today = new Date().toISOString().slice(0, 10);
        setPromos(
          (p.data || []).filter((x) => {
            if (x.is_daily) return !x.starts_at || x.starts_at === today;
            const startsOk = !x.starts_at || x.starts_at <= today;
            const endsOk = !x.ends_at || x.ends_at >= today;
            return startsOk && endsOk;
          })
        );
        setTiers(o.data || []);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading">{t('misc.loading')}</div>;

  return (
    <div className="container section">
      <h1>🏷️ {t('sale.title')}</h1>

      <h2>{t('sale.promos')}</h2>
      {promos.length === 0 && <div className="empty card">—</div>}
      <div className="grid grid-2" style={{ marginBottom: 36 }}>
        {promos.map((p) => (
          <div key={p.id} className="card">
            <div className="row" style={{ gap: 6 }}>
              {p.is_daily && <span className="badge badge-hot">⚡ {t('sale.today')}</span>}
              {p.discount_percent && <span className="badge badge-sale">-{Number(p.discount_percent)}%</span>}
            </div>
            <h3 style={{ margin: '8px 0 6px' }}>{pickLang(p, 'title', lang)}</h3>
            <p className="muted" style={{ margin: 0 }}>{pickLang(p, 'description', lang)}</p>
          </div>
        ))}
      </div>

      <h2>🎁 {t('sale.tiers')}</h2>
      <div className="grid grid-3" style={{ marginBottom: 24 }}>
        {tiers.map((tier) => (
          <div key={tier.id} className="card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 13, color: 'var(--mute)', textTransform: 'uppercase', fontWeight: 700 }}>
              {t('sale.tierFrom')}
            </div>
            <div style={{ fontSize: 26, fontWeight: 700, color: 'var(--ink)', margin: '4px 0' }}>
              {formatVND(tier.min_subtotal)}
            </div>
            <div>{pickLang(tier, 'reward', lang)}</div>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center' }}>
        <Link to="/products?filter=sale" className="btn btn-primary">{t('sale.shopNow')}</Link>
      </div>
    </div>
  );
}
